import { render, staticRenderFns } from "./ObserverSurveyCompleteForm.vue?vue&type=template&id=585fa02c&lang=html&"
import script from "./ObserverSurveyCompleteForm.vue?vue&type=script&lang=js&"
export * from "./ObserverSurveyCompleteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports